import { ExecutionEnvironment } from '../../ExecutionEnvironment'
import type { TAnime } from './interfaces'

const animations: Array<() => void> = []
let anime: TAnime | undefined

import('animejs').then(module => {
  anime = module.default
  animations.forEach(animate => animate())
})

export const setCounterAnimation = (node: HTMLDivElement) => {
  if (ExecutionEnvironment.isSsr || !node) return

  if (!node?.querySelector('.with-counter-animation')) return

  const animate = () => {
    const counterNode: HTMLSpanElement | null = node.querySelector('.with-counter-animation')

    ;(anime as TAnime)({
      opacity: 1,
      targets: counterNode,
      round: () => (counterNode?.dataset.round ? 10 : 1),
      duration: 1000,
      easing: 'linear',
      textContent: [0, Number(counterNode?.dataset.value)],
    })
  }

  if (anime) animate()
  else animations.push(animate)
}
